import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@app/core/graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    AlendumCategory,
    CreateAlendumCategoryInput,
    UpdateAlendumCategoryInput
} from '@app/core/services/api/API.service';

@Injectable({
    providedIn: 'root'
})
export class AlendumCategoryService {
    constructor() {}
    private amplifyClient = generateClient();

    async getAlendumCategory(id: string): Promise<AlendumCategory> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.getAlendumCategory,
                    variables: {
                        id
                    }
                })
            ).data.getAlendumCategory;
            if (data) return data as AlendumCategory;
        } catch (error) {
            console.error('Error listAlendumCategories:', error);
            return null;
        }
    }

    async listAlendumCategories(): Promise<AlendumCategory[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listAlendumCategories
                })
            ).data.listAlendumCategories.items;
            if (data) return data as AlendumCategory[];
        } catch (error) {
            console.error('Error listAlendumCategories:', error);
            return null;
        }
    }

    async createAlendumCategory(
        input: CreateAlendumCategoryInput
    ): Promise<AlendumCategory> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.createAlendumCategory,
                    variables: {
                        input
                    }
                })
            ).data.createAlendumCategory;
            if (date) return date as AlendumCategory;
        } catch (error) {
            console.error('Error creating AlendumCategory:', error);
            return null;
        }
    }

    async updateAlendumCategory(
        input: UpdateAlendumCategoryInput
    ): Promise<AlendumCategory> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.updateAlendumCategory,
                    variables: {
                        input
                    }
                })
            ).data.updateAlendumCategory;
            if (date) return date as AlendumCategory;
        } catch (error) {
            console.error('Error creating AlendumCategory:', error);
            return null;
        }
    }
}
